(function (angular) {
    'use strict';

    angular.module('templates')

        .controller("templateModal", ["$uibModalInstance", "WizardHandler", "template", "templatesData", "utilService", "uploadFileService", "sharedDataService", "profileSchema", "$rootScope",
            function ($uibModalInstance, WizardHandler, template, templatesData, utilService, uploadFileService, sharedDataService, profileSchema, $rootScope) {

                var vm = this;
                vm.wizardTitle = "Create or update a template";
                vm.profileSchema = profileSchema;
                vm.updating = false;
                vm.existingTemplates = angular.copy(templatesData);
                vm.existingIdCheck = function () {
                    var exist = vm.existingTemplates.filter(function (obj) {
                        return obj.id === vm.newTemplate.id;
                    }).length > 0;

                    return exist;
                };
                vm.cancel = function () {
                    if (vm.updating) {
                        template.messageParts = vm.messagePartsBeforeChange;
                    }
                    WizardHandler.wizard("templateWizard").cancel();
                    $uibModalInstance.dismiss();
                }

                vm.create = function () {
                    WizardHandler.wizard("templateWizard").finish();
                    $uibModalInstance.close(vm.buildRequest());
                }

                vm.nameExitValidation = function () {
                    return vm.nameNameStepForm.$valid;
                }

                vm.canEnterStepOne = function () {
                    return true;
                }

                function getSupportedTypes(type) {
                    var mappings = sharedDataService.getTypesMapping()[type];
                    return sharedDataService.getSupportedTypes(mappings);
                }

                vm.onKeyDown = function (event, isOpen) {
                    if (!event.shiftKey && event.keyCode == 13 && isOpen) {
                        event.preventDefault();
                    }
                }

                vm.detailsExitValidation = function () {
                    return (Object.values(vm.step2Model.messageParts).length > 0);
                }

                if (!vm.step2Model) {
                    vm.step2Model = {};
                }

                if (!vm.step2Model.messageParts) {
                    vm.step2Model.messageParts = [];
                }

                vm.addTextPart = function () {
                    vm.step2Model.messageParts.push({
                        type: "text/plain",
                        data: vm.newText,
                        id: utilService.uuid()
                    });
                    vm.newText = "";
                }

                vm.newTemplate = {
                    autoGenerateName: true,
                    type: ''
                };

                vm.removePart = function (part) {
                    var index = vm.step2Model.messageParts.indexOf(part);
                    if (index >= 0) {
                        var part = vm.step2Model.messageParts[index];
                        vm.step2Model.messageParts.splice(index, 1);
                    }
                }

                vm.editPart = function (part) {
                    //adding 1 to be able to check for editingPart existence
                    vm.editingPartIndex = vm.step2Model.messageParts.indexOf(part) + 1;
                    vm.lastText = vm.newText;
                    vm.newText = part.data;
                }


                vm.saveEditingPart = function () {
                    vm.step2Model.messageParts[vm.editingPartIndex - 1].data = vm.newText;
                    vm.newText = vm.lastText;
                    delete vm.editingPartIndex;
                }

                vm.cancelEditingPart = function () {
                    delete vm.editingPartIndex;
                    vm.newText = vm.lastText;
                }

                vm.generateId = function () {
                    if (!vm.updating) {
                        if (vm.newTemplate.name) {
                            vm.newTemplate.id = vm.newTemplate.name.replace(/[^a-zA-Z\d-_|]/g, "_");
                        }
                        else {
                            vm.newTemplate.id = '';
                        }
                    }
                };
                vm.addImagePart = function () {

                    uploadFileService.uploadCustomFile(null, {
                        typeName: "File"
                    }, false, getSupportedTypes('media')).then(function (data) {

                        vm.step2Model.messageParts.push({
                            type: data.type,
                            url: data.url,
                            size: data.size,
                            name: data.name,
                            id: utilService.uuid()
                        });
                    });
                }
                vm.mergePopoverTemplate = 'components/messageTemplates/templates/properties.html';

                vm.emojitextareaPaste = function (index) {
                    $rootScope.$broadcast("paste", {
                        id: 'text-input-templates',
                        text: "{{profile." + vm.profileSchema[index].path + "}}"
                    });
                }

                vm.initialise = function () {
                    if (template) {

                        vm.updating = true;
                        vm.wizardTitle = "Update template";

                        vm.newTemplate.name = template.name;
                        vm.newTemplate.description = template.description;
                        vm.newTemplate.id = template.id;
                        vm.step2Model.messageParts = template.messageParts;
                        vm.messagePartsBeforeChange = angular.copy(template.messageParts);
                    } else {
                        vm.wizardTitle = "Create template";
                    }
                }

                vm.buildRequest = function () {
                    var data = {
                        name: vm.newTemplate.name,
                        description: vm.newTemplate.description,
                        messageParts: vm.step2Model.messageParts,
                        id: template ? template.id : undefined
                    };
                    return data;

                }

                vm.initialise();

            }])
        .controller('previewTemplateModal', ["template", "$uibModalInstance", function (template, $uibModalInstance) {
            var vm = this;
            vm.template = template;

            vm.cancel = function () {
                $uibModalInstance.dismiss();
            }
        }]);

})(window.angular);
